<template>
  <div>
    <LaptopPanel v-if="isLaptop" :isLaptop="isLaptop" />
    <MobPanel v-else :isLaptop="isLaptop" />
  </div>
</template>

<script>
import LaptopPanel from "../jobs/PanelDetails.vue";
import MobPanel from "../panelLogin/Externalpanel.vue";
export default {
  data() {
    return {
      isLaptop: true,
    };
  },
  components: {
    LaptopPanel,
    MobPanel,
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  methods: {
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
  },
};
</script>
